import { AxiosInstance } from 'axios';
import type { GetBrands } from './interfaces/workspace.brand';
import * as WS from './interfaces/workspace.brand';
import { transformDates } from './transformers';

export class WorkspaceBrandsClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  getBrands = (data: GetBrands.Request) => {
    return this.authenticatedClient.get<GetBrands.Response>(`/workspaces/brands`, { params: data, transformResponse: transformDates });
  };

  getBrand = (data: WS.GetBrand.Request): Promise<WS.GetBrand.Response> => {
    return this.authenticatedClient.get(`/workspaces/brands/${data.brandId}`, {
      transformResponse: transformDates,
    })
      .then(({ data }) => data);
  };

  getProjects = (data: WS.GetProjects.Request) => {
    const { brandId, ...params } = data;

    return this.authenticatedClient.get(`/workspaces/brands/${data.brandId}/projects`, {
      params,
    })
      .then(({ data }) => data)
      .then((res: WS.GetProjects.Response<string>) => ({
        items: res.items.map<WS.GetProjects.ProjectItem>(x =>
          /* eslint-disable @typescript-eslint/ban-ts-comment */
          //@ts-ignore
          xform.normalizeProjectDates(x),
        ),
        pagination: res.pagination,
      }));
  };

  getProjectTracker = (data: WS.GetProjectTracker.Request): Promise<WS.GetProjectTracker.Response> => {
    return this.authenticatedClient.get(`/workspaces/brands/${data.brandId}/project-tracker`, {
      transformResponse: transformDates,
    })
      .then(({ data }) => data);
  };
}